<template>
	<div id="app" class="w-screen h-screen">
		<header class="flex items-center justify-between px-2 pt-2 md:pb-2 w-full max-w-xl mx-auto">
			<div>
				<h1 class="inline-block font-bold text-2xl">CodeReview</h1>
				<span class="ml-1">{{ version }}</span>
			</div>
			<nav>
				<router-link to="/" class="mr-2">Home</router-link>
				<router-link to="/about">About</router-link>
			</nav>
		</header>
		<router-view />
	</div>
</template>

<script>
export default {
	data() {
		return {
			version: process.env.VERSION,
		};
	},
	mounted() {
		/** Viewport height correction for iOS
		 * https://github.com/Faisal-Manzer/postcss-viewport-height-correction */
		function setViewportProperty(doc) {
			var prevClientHeight;
			const customVar = '--vh';
			function handleResize() {
				var clientHeight = doc.clientHeight;
				if (clientHeight === prevClientHeight) return;
				requestAnimationFrame(function updateViewportHeight() {
					doc.style.setProperty(customVar, clientHeight * 0.01 + 'px');
					prevClientHeight = clientHeight;
				});
			}
			handleResize();
			return handleResize;
		}
		window.addEventListener('resize', setViewportProperty(document.documentElement));
	},
};
</script>

<style>
@import 'tailwindcss/base';

* {
	box-sizing: border-box;
	position: relative;
}

select,
input,
textarea,
button {
	border: 1px solid;
	padding: 4px;
	border-radius: 4px;
}

button {
	@apply bg-blue-200;
}

a {
	@apply text-blue-600 underline;
}

@import 'tailwindcss/components';

@import 'tailwindcss/utilities';

#app {
	display: grid;
	grid-template-rows: auto minmax(0, 1fr);
	grid-template-columns: minmax(0, 1fr);
}
</style>
